import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogContentPlaceholderInterface } from 'common/types/entities/BlogContentPlaceholderInterface'
import { generateEntityWithChildIds } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createBlogContentPlaceholder(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
) {
  return {
    ...generateEntityWithChildIds(
      EntityTypeEnum.BlogContentPlaceholder,
      parentId,
      masterBlockId,
    ),
    padding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    isReadOnly: false,
  } as BlogContentPlaceholderInterface
}
